import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

export const SOLARWEBTRACKER_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

export const SOLARWEBTRACKER_TEST_CONFIG = {
  apiKey: process.env.REACT_APP_TEST_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_TEST_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_TEST_FIREBASE_DATABASE,
  messagingSenderId: process.env.REACT_APP_TEST_FIREBASE_SENDER_ID,
  projectId: process.env.REACT_APP_TEST_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_TEST_FIREBASE_STORAGE_BUCKET,
};

const firebaseApp: firebase.app.App = firebase.initializeApp(
  SOLARWEBTRACKER_CONFIG,
  SOLARWEBTRACKER_CONFIG.projectId
);
const fs = firebaseApp.firestore();
fs.settings({
  timestampsInSnapshots: true,
});
const fsStorage = firebaseApp.storage();
export { fsStorage };
export default { firebaseApp, fs, fsStorage };



// WEBPACK FOOTER //
// ./src/services/config/fbConfig.tsx